import {Config} from "@bainbridge-growth/node-frontend";
import ITelemetryProvider from "@services/telemetry/ITelemetryProvider";
import Telemetry from "@services/telemetry/Telemetry";

declare global {
  interface Window {
    Intercom: {
      (command: string, ...args: any[]): void;
      booted: boolean;
    };
    intercomSettings: Record<string, any>;
  }
}

export default class Intercom implements ITelemetryProvider {

  get name(): string { return "intercom"; }

  async embed(): Promise<void> {
    if (window.Intercom != null) { return; }
    const appId = Config.get("intercom.id");
    const i: any = function(...args: any[]) { i.c(args); };
    i.q = [];
    i.c = function(args: any[]) { i.q.push(args); };
    window.Intercom = i;
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${appId}`;
    document.getElementsByTagName("head")[0].appendChild(s);
  }

  async identify(): Promise<void> {
    if (!window.Intercom) { return; }
    if (!Telemetry.user) {
      window.Intercom("shutdown");
      return;
    }
    const {user, excelUser} = Telemetry.user;
    const payload: Record<string, any> = {
      app_id: Config.get("intercom.id"),
      api_base: Config.get("intercom.api_base"),
      user_id: user.uid,
      email: user.email,
      name: `${excelUser.firstName} ${excelUser.lastName}`,
      environment: Config.get("environment"),
      role: excelUser.role,
      webapp_version: Config.get("version")
    };
    if (Telemetry.company) {
      payload.company = {
        company_id: Telemetry.company.id,
        name: Telemetry.company.name
      };
    }
    if (window.Intercom.booted) {
      window.Intercom("update", payload);
    } else {
      window.Intercom("boot", payload);
    }
  }

  async track(event: string, data: any = {}): Promise<void> {
    if (!window.Intercom) { return; }
    window.Intercom("trackEvent", event, data);
  }

}
